import { apiClient } from '../apiClient';

export type NotificationType =
  | 'announcement'
  | 'assignment_created'
  | 'session_reminder'
  | 'feedback'
  | 'trainer_message'
  // The weekly placement-readiness review, sent to org admins. Unlike the
  // others this is not triggered by anyone's action — it is the review cadence
  // itself.
  | 'review_digest';

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  body: string;
  link?: string;
  read: boolean;
  created_at: string;
}

export const getNotifications = (limit = 20) =>
  apiClient.get<Notification[]>('/api/v1/notifications', {
    params: { limit },
  });

export const getUnreadCount = () =>
  apiClient.get<{ count: number }>('/api/v1/notifications/unread-count');

export const markNotificationsRead = (ids: string[]) =>
  apiClient.post('/api/v1/notifications/mark-read', { ids });

export const markAllNotificationsRead = () =>
  apiClient.post('/api/v1/notifications/mark-all-read');

export const postAnnouncement = (batchId: string, content: string) =>
  apiClient.post(`/api/v1/trainer/batches/${batchId}/announcements`, { content });
